import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Home, MessageCircle } from "lucide-react";

const LOGO_URL = "https://static.wixstatic.com/media/8cad63_34255d7d136a4ee78b0025c9136c48a4~mv2.png/v1/fill/w_302,h_74,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/8cad63_34255d7d136a4ee78b0025c9136c48a4~mv2.png";

const NotFoundPage = () => {
  useEffect(() => {
    document.title = "Page Not Found | Mayker Financial Group";
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F3] flex items-center justify-center px-4 pt-16" data-testid="404-page">
      <div className="text-center max-w-lg">
        {/* Logo */}
        <img 
          src={LOGO_URL} 
          alt="Mayker Financial Group" 
          className="h-12 mx-auto mb-8"
        />
        
        {/* 404 Number */}
        <div className="relative mb-6">
          <h1 className="font-playfair text-8xl lg:text-9xl font-bold text-[#0C1B33]/10">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-playfair text-2xl lg:text-3xl font-semibold text-[#0C1B33]">
              Page not found
            </span>
          </div>
        </div>
        
        {/* Friendly message */}
        <p className="text-[#6B7A99] mb-4 leading-relaxed">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>
        <p className="text-[#6B7A99] mb-8 leading-relaxed">
          Let's get you back on track — or reach out if you need help with life insurance, group benefits, or financial planning.
        </p>
        
        {/* Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link 
            to="/"
            className="inline-flex items-center gap-2 bg-[#0C1B33] text-white text-sm font-medium py-3.5 px-8 rounded hover:bg-[#162647] transition-colors w-full sm:w-auto justify-center"
            data-testid="404-home-button"
          >
            <Home className="w-4 h-4" />
            Back to Homepage
          </Link>
          <Link 
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#C9A84C] text-[#0C1B33] text-sm font-medium py-3.5 px-8 rounded hover:bg-[#E8CC80] transition-colors w-full sm:w-auto justify-center"
            data-testid="404-contact-button"
          >
            <MessageCircle className="w-4 h-4" />
            Contact Us
          </Link>
        </div>
        
        {/* Phone number */}
        <div className="mt-8 pt-6 border-t border-[#DDD8CC]">
          <p className="text-sm text-[#6B7A99] mb-2">Or call us directly:</p>
          <a 
            href="tel:7788361962"
            className="font-playfair text-xl font-semibold text-[#0C1B33] hover:text-[#C9A84C] transition-colors"
          >
            778-836-1962
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
